import { SET_DUMMY_TYPE } from "../types";

const INITIAL_STATE = {
  info: {},
};

const DummyReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_DUMMY_TYPE:
      return {
        ...state,
        info: action.payload,
      };

    default:
      return state;
  }
};

export default DummyReducer;